import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from "@angular/core";
import { FormControl } from "@angular/forms";

import { Observable, Subscription, BehaviorSubject } from "rxjs";
import { map, withLatestFrom } from "rxjs/operators";

import { TopicFormService } from "../../services/topic-form.service";

import {
  UserSummaryContactService,
  UserSummaryContact
} from "@onsip/common/services/api/resources/userSummaryContact/user-summary-contact.service";
import { WebCallTopicRep } from "@onsip/common/services/api/resources/webCallTopic/web-call-topic-rep";

@Component({
  selector: "onsip-rep-picker",
  templateUrl: "./rep-picker.component.html",
  styleUrls: ["./rep-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RepPickerComponent implements OnInit, OnDestroy {
  @Input() set initialValue(initialValue: Array<WebCallTopicRep>) {
    this._initialValue.next(initialValue);
  }

  @Output() updateRepCount = new EventEmitter<number>();

  allReps!: Observable<Array<UserSummaryContact>>;
  formControl = new FormControl();

  private _initialValue = new BehaviorSubject<Array<WebCallTopicRep>>([]);
  private unsubscriber = new Subscription();

  constructor(
    private userSummaryContacts: UserSummaryContactService,
    private topicForm: TopicFormService
  ) {}

  ngOnInit() {
    this.allReps = this.userSummaryContacts.state.pipe(
      map(users =>
        Object.values(users.state).sort((a, b) => (a.contactName > b.contactName ? 1 : -1))
      )
    );

    this.unsubscriber.add(
      this.formControl.valueChanges.subscribe((reps: Array<any>) =>
        this.updateRepCount.emit(reps.length)
      )
    );

    this.unsubscriber.add(
      this._initialValue
        .asObservable()
        .pipe(withLatestFrom(this.userSummaryContacts.state.pipe(map(substate => substate.state))))
        .subscribe(([webCallTopicReps, userSummaryContacts]) => {
          this.formControl.setValue(
            webCallTopicReps
              .filter(webCallTopicRep => {
                const found = userSummaryContacts[webCallTopicRep.repId];
                return !!found;
              })
              .map(({ repId }) => repId + "")
          );
        })
    );

    this.topicForm.addControl("reps", this.formControl);
  }

  ngOnDestroy() {
    this.unsubscriber.unsubscribe();
  }
}
